export const basicOptions = {
  maintainAspectRatio: false,
  legend: {
    display: true,
  },
  responsive: true,
};
export let blueChartOptions = {
  ...basicOptions,
  tooltips: {
    backgroundColor: "#f5f5f5",
    titleFontColor: "#333",
    bodyFontColor: "#666",
    bodySpacing: 4,
    xPadding: 12,
    mode: "nearest",
    intersect: 0,
    position: "nearest",
  },
  scales: {
    yAxes: [
      {
        barPercentage: 1.6,
        gridLines: {
          drawBorder: false,
          color: "rgba(29,140,248,0.0)",
          zeroLineColor: "transparent",
        },
        ticks: {
          suggestedMin: 60,
          suggestedMax: 125,
          padding: 20,
          fontColor: "#2380f7",
        },
      },
    ],

    xAxes: [
      {
        barPercentage: 1.6,
        gridLines: {
          drawBorder: false,
          color: "rgba(29,140,248,0.1)",
          zeroLineColor: "transparent",
        },
        ticks: {
          padding: 20,
          fontColor: "#2380f7",
        },
      },
    ],
  },
};

export let lineChartOptionsBlue = {
  ...basicOptions,
  tooltips: {
    backgroundColor: "#f5f5f5",
    titleFontColor: "#333",
    bodyFontColor: "#666",
    bodySpacing: 4,
    xPadding: 12,
    mode: "nearest",
    intersect: 0,
    position: "nearest",
  },
  responsive: true,
  scales: {
    yAxes: [
      {
        barPercentage: 1.6,
        gridLines: {
          drawBorder: false,
          color: "rgba(29,140,248,0.0)",
          zeroLineColor: "transparent",
        },
        ticks: {
          suggestedMin: 60,
          suggestedMax: 125,
          padding: 20,
          fontColor: "#9e9e9e",
        },
      },
    ],

    xAxes: [
      {
        barPercentage: 1.6,
        gridLines: {
          drawBorder: false,
          color: "rgba(29,140,248,0.1)",
          zeroLineColor: "transparent",
        },
        ticks: {
          padding: 20,
          fontColor: "#9e9e9e",
        },
      },
    ],
  },
};
export let commonChartOptions = {
  ...basicOptions,
  tooltips: {
    backgroundColor: "#f5f5f5",
    titleFontColor: "#333",
    bodyFontColor: "#666",
    bodySpacing: 4,
    xPadding: 12,
    mode: "nearest",
    intersect: 0,
    position: "nearest",
  },
  responsive: true,
  scales: {
    yAxes: [
      {
        barPercentage: 1.6,
        gridLines: {
          drawBorder: false,
          color: "rgba(29,140,248,0.0)",
          zeroLineColor: "transparent",
        },
        ticks: {
          suggestedMin: 60,
          suggestedMax: 125,
          padding: 20,
          fontColor: "#9e9e9e",
        },
      },
    ],

    xAxes: [
      {
        barPercentage: 1.6,
        gridLines: {
          drawBorder: false,
          color: "rgba(29,140,248,0.1)",
          zeroLineColor: "transparent",
        },
        ticks: {
          padding: 20,
          fontColor: "#9e9e9e",
        },
      },
    ],
  },
};

export let barChartOptionsGradient = {
  ...basicOptions,
  tooltips: {
    backgroundColor: "#f5f5f5",
    titleFontColor: "#333",
    bodyFontColor: "#666",
    bodySpacing: 4,
    xPadding: 12,
    mode: "nearest",
    intersect: 0,
    position: "nearest",
  },
  responsive: true,
  scales: {
    yAxes: [
      {
        gridLines: {
          drawBorder: false,
          color: "rgba(253,93,147,0.1)",
          zeroLineColor: "transparent",
        },
        ticks: {
          suggestedMin: 0,
          suggestedMax: 5,
          padding: 20,
          fontColor: "#9e9e9e",
        },
      },
    ],

    xAxes: [
      {
        gridLines: {
          drawBorder: false,
          color: "rgba(253,93,147,0.1)",
          zeroLineColor: "transparent",
        },
        ticks: {
          padding: 20,
          fontColor: "#9e9e9e",
        },
      },
    ],
  },
};

export let demooptions = {
  options: {
    responsive: true,
    scales: {
      x: {
        display: true,
        title: {
          display: true,
          text: 'Month',
          color: '#911',
          font: {
            family: 'Comic Sans MS',
            size: 20,
            weight: 'bold',
            lineHeight: 1.2,
          },
          padding: { top: 20, left: 0, right: 0, bottom: 0 }
        }
      },
      y: {
        display: true,
        title: {
          display: true,
          text: 'Value',
          color: '#191',
          font: {
            family: 'Times',
            size: 20,
            style: 'normal',
            lineHeight: 1.2
          },
          padding: { top: 30, left: 0, right: 0, bottom: 0 }
        }
      }
    }
  },
};

export let commonChartOptionss = {
  ...basicOptions,
  tooltips: {
    backgroundColor: "#f5f5f5",
    titleFontColor: "#333",
    bodyFontColor: "#666",
    bodySpacing: 4,
    xPadding: 12,
    mode: "nearest",
    intersect: 0,
    position: "nearest",
  },
  responsive: true,
  scales: {
    yAxes: [
      {
        barPercentage: 1.6,
        gridLines: {
          drawBorder: false,
          color: "rgba(29,140,248,0.0)",
          zeroLineColor: "transparent",
        },
        ticks: {
          suggestedMin: 60,
          suggestedMax: 125,
          padding: 20,
          fontColor: "#9e9e9e",
        },
      },
    ],

    xAxes: [
      {
        barPercentage: 1.6,
        gridLines: {
          drawBorder: false,
          color: "rgba(29,140,248,0.1)",
          zeroLineColor: "transparent",
        },
        ticks: {
          padding: 20,
          fontColor: "#9e9e9e",
        },
      },
    ],
  },
};

export let barChartOptionsGradient2 = {
  ...basicOptions,
  tooltips: {
    backgroundColor: "#f5f5f5",
    titleFontColor: "#333",
    bodyFontColor: "#666",
    bodySpacing: 4,
    xPadding: 12,
    mode: "nearest",
    intersect: 0,
    position: "nearest",
  },
  legend: {
    display: false
  },
  responsive: true,
  scales: {
    yAxes: [
      {

        type: "linear",
        position: "left",
        ticks: {
          suggestedMin: 0,
        }
      },
      // {
      //   id: "y-axis-2",
      //   type: "linear",
      //   position: "right",
      //   ticks: {
      //     suggestedMin: 0,   
      //   }
      // },
    ],



  },
};

export let barChartOptionsGradient3 = {
  ...basicOptions,
  tooltips: {
    backgroundColor: "#f5f5f5",
    titleFontColor: "#333",
    bodyFontColor: "#666",
    bodySpacing: 4,
    xPadding: 12,
    mode: "nearest",
    intersect: 0,
    position: "nearest",
  },
  legend: {
    display: true
  },
  responsive: true,
  scales: {
    x: {
      title: {
        display: true,
        text: 'Your X-Axis Title',  // Replace with your desired x-axis title
        font: {
          size: 14  // Customize font size as needed
        }
      }
    },
    y: {
      title: {
        display: true,
        text: 'Your Y-Axis Title',  // Replace with your desired y-axis title
        font: {
          size: 14  // Customize font size as needed
        }
      },
      min: 0,  // Set minimum value for y-axis if needed
      type: "linear",
      position: "left",
      ticks: {
        suggestedMin: 0,
      }
    }
  }
};


export let percentageBarChart = {
  ...basicOptions,
  tooltips: {
    backgroundColor: "#f5f5f5",
    titleFontColor: "#333",
    bodyFontColor: "#666",
    bodySpacing: 4,
    xPadding: 20,
    mode: "x",
    intersect: 0,
    position: "nearest",
  },
  legend: {
    display: true,
    position: "top",
    align: "center",
    labels: {
      // usePointStyle : true,
      fontSize: 12,
      fontColor: "#9e9e9e",
    },
  },
  responsive: true,
  scales: {
    yAxes: [
      {
        barPercentage: 1.6,
        gridLines: {
          drawBorder: false,
          color: "rgba(29,140,248,0.0)",
          zeroLineColor: "transparent",
        },
        ticks: {
          suggestedMin: 1,
          suggestedMax: 5,
          padding: 20,
          fontColor: "#9e9e9e",
          precision: 0,
        },
      },
    ],

    xAxes: [
      {
        barPercentage: 1.6,
        gridLines: {
          drawBorder: false,
          color: "rgba(225,78,202,0.1)",
          zeroLineColor: "transparent",
        },
        ticks: {
          padding: 20,
          fontColor: "#9e9e9e",
        },
      },
    ],
  },
};

export let pieChartOptions = {
  ...basicOptions,
  // animation: {
  //   duration: 0
  // },
  // hover: {
  //   animationDuration: 0
  // },
  // responsiveAnimationDuration: 0,
  // Add title configuration
  cutoutPercentage: 85,
  legend: {
    display: false,
    position: "right",
    align: "center",
    labels: {
      usePointStyle: true,
      fontSize: 14,
      fontColor: "gray",
      boxWidth: 12,
    },
  },
  tooltips: {
    backgroundColor: "#f5f5f5",
    titleFontColor: "#333",
    bodyFontColor: "#666",
    bodySpacing: 4,
    xPadding: 12,
    mode: "nearest",
    intersect: 0,
    position: "nearest",
  },

  scales: {
    yAxes: [
      {
        display: 0,
        ticks: {
          display: false,
        },
        gridLines: {
          drawBorder: false,
          zeroLineColor: "transparent",
          color: "rgba(255,255,255,0.05)",
        },
      },
    ],

    xAxes: [
      {
        display: 0,
        barPercentage: 1.6,
        gridLines: {
          drawBorder: false,
          color: "rgba(255,255,255,0.1)",
          zeroLineColor: "transparent",
        },
        ticks: {
          display: false,
        },
      },
    ],
  },
};

export let pieChartOptions1 = {
  ...basicOptions,
  // animation: {
  //   duration: 0
  // },
  // hover: {
  //   animationDuration: 0
  // },
  // responsiveAnimationDuration: 0,
  // Add title configuration
  // cutoutPercentage: 85,
  legend: {
    display: true,
    position: "right",
    align: "center",
    labels: {
      usePointStyle: false,
      fontSize: 14,
      fontColor: "gray",
      boxWidth: 12,
    },
  },
  tooltips: {
    backgroundColor: "#f5f5f5",
    titleFontColor: "#333",
    bodyFontColor: "#666",
    bodySpacing: 4,
    xPadding: 12,
    mode: "nearest",
    intersect: 0,
    position: "nearest",
  },

  scales: {
    yAxes: [
      {
        display: 0,
        ticks: {
          display: true,
        },
        gridLines: {
          drawBorder: false,
          zeroLineColor: "transparent",
          color: "rgba(255,255,255,0.05)",
        },
      },
    ],

    xAxes: [
      {
        display: 0,
        barPercentage: 1.6,
        gridLines: {
          drawBorder: false,
          color: "rgba(255,255,255,0.1)",
          zeroLineColor: "transparent",
        },
        ticks: {
          display: true,
        },
      },
    ],
  },
};

export let pieChartOptions15 = {
  ...basicOptions,
  // animation: {
  //   duration: 0
  // },
  // hover: {
  //   animationDuration: 0
  // },
  // responsiveAnimationDuration: 0,
  // Add title configuration
  // cutoutPercentage: 85,
  legend: {
    display: true,
    position: "bottom",
    align: "center",
    labels: {
      usePointStyle: false,
      fontSize: 14,
      fontColor: "gray",
      boxWidth: 12,
    },
  },
  tooltips: {
    backgroundColor: "#f5f5f5",
    titleFontColor: "#333",
    bodyFontColor: "#666",
    bodySpacing: 4,
    xPadding: 12,
    mode: "nearest",
    intersect: 0,
    position: "nearest",
  },

  scales: {
    yAxes: [
      {
        display: 0,
        ticks: {
          display: true,
        },
        gridLines: {
          drawBorder: false,
          zeroLineColor: "transparent",
          color: "rgba(255,255,255,0.05)",
        },
      },
    ],

    xAxes: [
      {
        display: 0,
        barPercentage: 1.6,
        gridLines: {
          drawBorder: false,
          color: "rgba(255,255,255,0.1)",
          zeroLineColor: "transparent",
        },
        ticks: {
          display: true,
        },
      },
    ],
  },
};

export let pieChartOptions16 = {
  ...basicOptions,
  // animation: {
  //   duration: 0
  // },
  // hover: {
  //   animationDuration: 0
  // },
  // responsiveAnimationDuration: 0,
  // Add title configuration
  // cutoutPercentage: 85,
  legend: {
    display: true,
    position: "left",
    align: "center",
    labels: {
      usePointStyle: false,
      fontSize: 14,
      fontColor: "gray",
      boxWidth: 12,
    },
  },
  tooltips: {
    backgroundColor: "#f5f5f5",
    titleFontColor: "#333",
    bodyFontColor: "#666",
    bodySpacing: 4,
    xPadding: 12,
    mode: "nearest",
    intersect: 0,
    position: "nearest",
  },

  scales: {
    yAxes: [
      {
        display: 0,
        ticks: {
          display: true,
        },
        gridLines: {
          drawBorder: false,
          zeroLineColor: "transparent",
          color: "rgba(255,255,255,0.05)",
        },
      },
    ],

    xAxes: [
      {
        display: 0,
        barPercentage: 1.6,
        gridLines: {
          drawBorder: false,
          color: "rgba(255,255,255,0.1)",
          zeroLineColor: "transparent",
        },
        ticks: {
          display: true,
        },
      },
    ],
  },
};

export let pieChartOptions2 = {
  ...basicOptions,
  // animation: {
  //   duration: 0
  // },
  // hover: {
  //   animationDuration: 0
  // },
  // responsiveAnimationDuration: 0,
  cutoutPercentage: 80,
  legend: {
    display: false,
    position: "right",
    align: "center",
    labels: {
      // usePointStyle : true,
      fontSize: 12,
      fontColor: "white",
      boxWidth: 12,
    },
  },
  tooltips: {
    backgroundColor: "#f5f5f5",
    titleFontColor: "#333",
    bodyFontColor: "#666",
    bodySpacing: 4,
    xPadding: 12,
    mode: "nearest",
    intersect: 0,
    position: "nearest",
  },

  scales: {
    yAxes: [
      {
        display: 0,
        ticks: {
          display: false,
        },
        gridLines: {
          drawBorder: false,
          zeroLineColor: "transparent",
          color: "rgba(255,255,255,0.05)",
        },
      },
    ],

    xAxes: [
      {
        display: 0,
        barPercentage: 1.6,
        gridLines: {
          drawBorder: false,
          color: "rgba(255,255,255,0.1)",
          zeroLineColor: "transparent",
        },
        ticks: {
          display: false,
        },
      },
    ],
  },
};

export let binaryOptions = {
  ...basicOptions,
  tooltips: {
    backgroundColor: "#f5f5f5",
    titleFontColor: "#333",
    bodyFontColor: "#666",
    bodySpacing: 4,
    xPadding: 12,
    mode: "nearest",
    intersect: 0,
    position: "nearest",
  },
  scales: {
    yAxes: [
      {
        barPercentage: 1.6,
        gridLines: {
          drawBorder: false,
          color: "rgba(29,140,248,0.0)",
          zeroLineColor: "transparent",
        },
        ticks: {
          beginAtZero: true,
          userCallback: function (label, index, labels) {
            // when the floored value is the same as the value we have a whole number
            if (Math.floor(label) === label) {
              return label;
            }
          },
          suggestedMin: 0,
          suggestedMax: 1,
          padding: 20,
          fontColor: "#9a9a9a",
        },
      },
    ],

    xAxes: [
      {
        barPercentage: 1.6,
        gridLines: {
          drawBorder: false,
          color: "rgba(225,78,202,0.1)",
          zeroLineColor: "transparent",
        },
        ticks: {
          padding: 20,
          fontColor: "#9a9a9a",
        },
      },
    ],
  },
};
export let purpleChartOptionslll = {
  maintainAspectRatio: false,
  // elements: {
  //   line: {
  //     tension: 0, // smooth lines
  //   },
  // },
  legend: {
    display: false,
    position: "top",
    labels: {
      usePointStyle: true,
      pointStyle: {
        margin: "10px",
      },
      boxWidth: 10,
      fontColor: "white",
    },
  },
  tooltips: {
    backgroundColor: "#f5f5f5",
    titleFontColor: "#333",
    bodyFontColor: "#666",
    bodySpacing: 4,
    xPadding: 12,
    mode: "nearest",
    intersect: 0,
    position: "nearest",
  },
  responsive: true,
  interaction: {
    mode: "index",
    intersect: false,
  },
  stacked: false,
  plugins: {
    title: {
      display: true,
      text: "Chart.js Line Chart - Multi Axis",
    },
  },
  scales: {
    yAxes: [
      {
        id: "y-axis-1",
        type: "linear",
        position: "left",
        ticks: {
          suggestedMin: 0,
        }
      },
      {
        id: "y-axis-2",
        type: "linear",
        position: "right",
        ticks: {
          suggestedMin: 0,
        }
      },
    ],
    // yAxes: [
    //   {
    //     barPercentage: 1.6,
    //     gridLines: {
    //       drawBorder: false,
    //       color: 'rgba(29,140,248,0.0)',
    //       zeroLineColor: 'transparent'
    //     },
    //     ticks: {
    //       suggestedMin: 1,
    //       suggestedMax: 5,
    //       padding: 20,
    //       fontColor: '#9a9a9a',
    //       precision:0
    //     }
    //   }
    // ],

    // xAxes: [
    //   {
    //     barPercentage: 1.6,
    //     gridLines: {
    //       drawBorder: false,
    //       color: 'rgba(225,78,202,0.1)',
    //       zeroLineColor: 'transparent'
    //     },
    //     ticks: {
    //       padding: 20,
    //       fontColor: '#9a9a9a'
    //     }
    //   }
    // ]
  },
};

export let purpleChartOptionsllls = {
  maintainAspectRatio: false,
  // elements: {
  //   line: {
  //     tension: 0, // smooth lines
  //   },
  // },
  legend: {
    display: true,
    position: "top",
    labels: {
      usePointStyle: true,
      pointStyle: {
        margin: "10px",
      },
      boxWidth: 10,
      // fontColor: "black",
    },
  },
  tooltips: {
    backgroundColor: "#f5f5f5",
    titleFontColor: "#333",
    bodyFontColor: "#666",
    bodySpacing: 4,
    xPadding: 12,
    mode: "nearest",
    intersect: 0,
    position: "nearest",
  },
  responsive: true,
  interaction: {
    mode: "index",
    intersect: false,
  },
  stacked: false,
  plugins: {
    title: {
      display: true,
      text: "Chart.js Line Chart - Multi Axis",
    },
  },
  scales: {
    yAxes: [
      {
        id: "y-axis-1",
        type: "linear",
        position: "left",
        ticks: {
          suggestedMin: 0,
        }
      },
      {
        id: "y-axis-2",
        type: "linear",
        position: "right",
        ticks: {
          suggestedMin: 0,
        }
      },
    ],
    // yAxes: [
    //   {
    //     barPercentage: 1.6,
    //     gridLines: {
    //       drawBorder: false,
    //       color: 'rgba(29,140,248,0.0)',
    //       zeroLineColor: 'transparent'
    //     },
    //     ticks: {
    //       suggestedMin: 1,
    //       suggestedMax: 5,
    //       padding: 20,
    //       fontColor: '#9a9a9a',
    //       precision:0
    //     }
    //   }
    // ],

    // xAxes: [
    //   {
    //     barPercentage: 1.6,
    //     gridLines: {
    //       drawBorder: false,
    //       color: 'rgba(225,78,202,0.1)',
    //       zeroLineColor: 'transparent'
    //     },
    //     ticks: {
    //       padding: 20,
    //       fontColor: '#9a9a9a'
    //     }
    //   }
    // ]
  },
};

export let purpleChartOptionsllll = {
  maintainAspectRatio: false,

  legend: {
    display: false,
    position: "top",
    labels: {
      usePointStyle: true,
      pointStyle: {
        margin: "10px",
      },
      boxWidth: 10,
      fontColor: "white",
    },
  },
  tooltips: {
    backgroundColor: "#f5f5f5",
    titleFontColor: "#333",
    bodyFontColor: "#666",
    bodySpacing: 4,
    xPadding: 12,
    mode: "nearest",
    intersect: 0,
    position: "nearest",
  },
  responsive: true,
  interaction: {
    mode: "index",
    intersect: false,
  },
  stacked: false,
  plugins: {
    title: {
      display: true,
      text: "Chart.js Line Chart - Multi Axis",
    },
  },
  scales: {
    yAxes: [
      {
        id: "a",
        type: "linear",
        position: "left",
        ticks: {
          suggestedMin: 0,
        }
      },
      {
        id: "b",
        type: "linear",
        position: "right",
        ticks: {
          suggestedMin: 0,
        }
      },
    ],

  },
};

export let blueChartOptionss = {
  maintainAspectRatio: false,
  // elements: {
  //   line: {
  //     tension: 0, // smooth lines
  //   },
  // },
  legend: {
    display: false,
    position: "top",
    labels: {
      usePointStyle: true,
      pointStyle: {
        margin: "10px",
      },
      boxWidth: 10,
      fontColor: "white",
    },
  },
  tooltips: {
    backgroundColor: "#f5f5f5",
    titleFontColor: "#333",
    bodyFontColor: "#666",
    bodySpacing: 4,
    xPadding: 12,
    mode: "nearest",
    intersect: 0,
    position: "nearest",
  },
  responsive: true,
  interaction: {
    mode: "index",
    intersect: false,
  },
  stacked: false,
  plugins: {
    title: {
      display: true,
      text: "Chart.js Line Chart - Multi Axis",
    },
  },
  scales: {
    yAxes: [
      {
        id: "y-axis-1",
        type: "linear",
        position: "left",
        ticks: {
          suggestedMin: 0,
        }
      },
      // {
      //   id: "y-axis-2",
      //   type: "linear",
      //   position: "right",
      //   ticks: {
      //     suggestedMin: 0,   
      //   }
      // },
    ],
    // yAxes: [
    //   {
    //     barPercentage: 1.6,
    //     gridLines: {
    //       drawBorder: false,
    //       color: 'rgba(29,140,248,0.0)',
    //       zeroLineColor: 'transparent'
    //     },
    //     ticks: {
    //       suggestedMin: 1,
    //       suggestedMax: 5,
    //       padding: 20,
    //       fontColor: '#9a9a9a',
    //       precision:0
    //     }
    //   }
    // ],

    // xAxes: [
    //   {
    //     barPercentage: 1.6,
    //     gridLines: {
    //       drawBorder: false,
    //       color: 'rgba(225,78,202,0.1)',
    //       zeroLineColor: 'transparent'
    //     },
    //     ticks: {
    //       padding: 20,
    //       fontColor: '#9a9a9a'
    //     }
    //   }
    // ]
  },
};



export let purpleChartOptionsll = {
  maintainAspectRatio: false,

  legend: {
    display: false,
    position: "top",
    labels: {
      usePointStyle: true,
      pointStyle: {
        margin: "10px",
      },
      boxWidth: 10,
      fontColor: "white",
    },
  },
  tooltips: {
    backgroundColor: "#f5f5f5",
    titleFontColor: "#333",
    bodyFontColor: "#666",
    bodySpacing: 4,
    xPadding: 12,
    mode: "nearest",
    intersect: 0,
    position: "nearest",
  },
  scales: {
    yAxes: [
      {
        barPercentage: 1.6,
        gridLines: {
          drawBorder: false,
          color: "rgba(29,140,248,0.0)",
          zeroLineColor: "transparent",
        },
        ticks: {
          suggestedMin: 1,
          suggestedMax: 5,
          padding: 20,
          fontColor: "#9a9a9a",
          precision: 0,
        },
      },
    ],

    xAxes: [
      {
        barPercentage: 1.6,
        gridLines: {
          drawBorder: false,
          color: "rgba(225,78,202,0.1)",
          zeroLineColor: "transparent",
        },
        ticks: {
          padding: 20,
          fontColor: "#9a9a9a",
        },
      },
    ],
  },
};

export let purpleChartOptions = {
  ...basicOptions,
  tooltips: {
    backgroundColor: "#f5f5f5",
    titleFontColor: "#333",
    bodyFontColor: "#666",
    bodySpacing: 4,
    xPadding: 12,
    mode: "nearest",
    intersect: 0,
    position: "nearest",
  },
  scales: {
    yAxes: [
      {
        barPercentage: 1.6,
        gridLines: {
          drawBorder: false,
          color: "rgba(29,140,248,0.0)",
          zeroLineColor: "transparent",
        },
        ticks: {
          suggestedMin: 1,
          suggestedMax: 5,
          padding: 20,
          fontColor: "#9a9a9a",
          precision: 0,
        },
      },
    ],

    xAxes: [
      {
        barPercentage: 1.6,
        gridLines: {
          drawBorder: false,
          color: "rgba(225,78,202,0.1)",
          zeroLineColor: "transparent",
        },
        ticks: {
          padding: 20,
          fontColor: "#9a9a9a",
        },
      },
    ],
  },
};

export let percentChartOptions = {
  ...basicOptions,
  tooltips: {
    backgroundColor: "#f5f5f5",
    titleFontColor: "#333",
    bodyFontColor: "#666",
    bodySpacing: 4,
    xPadding: 12,
    mode: "nearest",
    intersect: 0,
    position: "nearest",
  },
  scales: {
    yAxes: [
      {
        barPercentage: 1.6,
        gridLines: {
          drawBorder: false,
          color: "rgba(29,140,248,0.0)",
          zeroLineColor: "transparent",
        },
        ticks: {
          suggestedMin: 0,
          suggestedMax: 100,
          padding: 20,
          fontColor: "#9a9a9a",
        },
      },
    ],

    xAxes: [
      {
        barPercentage: 1.6,
        gridLines: {
          drawBorder: false,
          color: "rgba(225,78,202,0.1)",
          zeroLineColor: "transparent",
        },
        ticks: {
          padding: 20,
          fontColor: "#9a9a9a",
        },
      },
    ],
  },
};

export let orangeChartOptions = {
  ...basicOptions,
  tooltips: {
    backgroundColor: "#f5f5f5",
    titleFontColor: "#333",
    bodyFontColor: "#666",
    bodySpacing: 4,
    xPadding: 12,
    mode: "nearest",
    intersect: 0,
    position: "nearest",
  },
  scales: {
    yAxes: [
      {
        barPercentage: 1.6,
        gridLines: {
          drawBorder: false,
          color: "rgba(29,140,248,0.0)",
          zeroLineColor: "transparent",
        },
        ticks: {
          suggestedMin: 50,
          suggestedMax: 110,
          padding: 20,
          fontColor: "#ff8a76",
        },
      },
    ],

    xAxes: [
      {
        barPercentage: 1.6,
        gridLines: {
          drawBorder: false,
          color: "rgba(220,53,69,0.1)",
          zeroLineColor: "transparent",
        },
        ticks: {
          padding: 20,
          fontColor: "#ff8a76",
        },
      },
    ],
  },
};
export let greenChartOptions = {
  ...basicOptions,
  tooltips: {
    backgroundColor: "#f5f5f5",
    titleFontColor: "#333",
    bodyFontColor: "#666",
    bodySpacing: 4,
    xPadding: 12,
    mode: "nearest",
    intersect: 0,
    position: "nearest",
  },
  scales: {
    yAxes: [
      {
        barPercentage: 1.6,
        gridLines: {
          drawBorder: false,
          color: "rgba(29,140,248,0.0)",
          zeroLineColor: "transparent",
        },
        ticks: {
          suggestedMin: 50,
          suggestedMax: 125,
          padding: 20,
          fontColor: "#9e9e9e",
        },
      },
    ],

    xAxes: [
      {
        barPercentage: 1.6,
        gridLines: {
          drawBorder: false,
          color: "rgba(0,242,195,0.1)",
          zeroLineColor: "transparent",
        },
        ticks: {
          padding: 20,
          fontColor: "#9e9e9e",
        },
      },
    ],
  },
};

export let barChartOptions = {
  ...basicOptions,
  tooltips: {
    backgroundColor: "#f5f5f5",
    titleFontColor: "#333",
    bodyFontColor: "#666",
    bodySpacing: 4,
    xPadding: 12,
    mode: "nearest",
    intersect: 0,
    position: "nearest",
  },
  scales: {
    yAxes: [
      {
        gridLines: {
          drawBorder: false,
          color: "rgba(29,140,248,0.1)",
          zeroLineColor: "transparent",
        },
        ticks: {
          suggestedMin: 60,
          suggestedMax: 120,
          padding: 20,
          fontColor: "#9e9e9e",
        },
      },
    ],
    xAxes: [
      {
        gridLines: {
          drawBorder: false,
          color: "rgba(29,140,248,0.1)",
          zeroLineColor: "transparent",
        },
        ticks: {
          padding: 20,
          fontColor: "#9e9e9e",
        },
      },
    ],
  },
};
